import { Contact } from "@/types/contacts";
import { Card, CardContent } from "@/components/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface ContactFilterPanelProps {
  contacts: Contact[];
  selectedRegion: string;
  selectedState: string;
  selectedType: string;
  selectedCompany: string;
  searchName: string;
  onRegionChange: (region: string) => void;
  onStateChange: (state: string) => void;
  onTypeChange: (type: string) => void;
  onCompanyChange: (company: string) => void;
  onSearchNameChange: (name: string) => void;
}

export function ContactFilterPanel({
  contacts,
  selectedRegion,
  selectedState,
  selectedType,
  selectedCompany,
  searchName,
  onRegionChange,
  onStateChange,
  onTypeChange,
  onCompanyChange,
  onSearchNameChange,
}: ContactFilterPanelProps) {
  const regions = Array.from(new Set(contacts.map((c) => c.region).filter(Boolean)));
  const states = Array.from(new Set(contacts.map((c) => c.state).filter(Boolean)));
  const companies = Array.from(new Set(contacts.map((c) => c.company).filter(Boolean))).sort();

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="space-y-4">
          {/* Campo de busca por nome */}
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Buscar por nome, sobrenome ou empresa..."
              value={searchName}
              onChange={(e) => onSearchNameChange(e.target.value)}
              className="pl-10"
            />
          </div>

          {/* Filtros em linha */}
          <div className="grid gap-4 md:grid-cols-4">
            <div className="space-y-2">
            <Label htmlFor="type">Tipo</Label>
            <Select value={selectedType} onValueChange={onTypeChange}>
              <SelectTrigger id="type">
                <SelectValue placeholder="Todos os tipos" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todos os tipos</SelectItem>
                <SelectItem value="restaurant">Restaurantes</SelectItem>
                <SelectItem value="operator">Operadoras</SelectItem>
                <SelectItem value="consolidator">Consolidadoras</SelectItem>
                <SelectItem value="rsvp">RSVP</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="region">Região</Label>
            <Select value={selectedRegion} onValueChange={onRegionChange}>
              <SelectTrigger id="region">
                <SelectValue placeholder="Todas as regiões" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todas as regiões</SelectItem>
                {regions.map((region) => (
                  <SelectItem key={region} value={region}>
                    {region}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="state">Estado</Label>
            <Select value={selectedState} onValueChange={onStateChange}>
              <SelectTrigger id="state">
                <SelectValue placeholder="Todos os estados" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todos os estados</SelectItem>
                {states.map((state) => (
                  <SelectItem key={state} value={state}>
                    {state}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="company">Empresa</Label>
            <Select value={selectedCompany} onValueChange={onCompanyChange}>
              <SelectTrigger id="company">
                <SelectValue placeholder="Todas as empresas" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todas as empresas</SelectItem>
                {companies.map((company) => (
                  <SelectItem key={company} value={company}>
                    {company}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
